import { ajax } from '../../helpers';

export const postLessonProgress = (lessonId, childProgress) => {
  return ajax
    .post(`/lessons/${lessonId}/save_progress`, childProgress)
    .then(response => response)
    .catch(error => console.log('postLessonProgress error: ', error))
};
